export const PIXEL_ID = '1493847205417473'

export function initMetaPixel() {
  if (typeof window === 'undefined') return

  // Force-clear any previously cached/stale pixel instance
  // @ts-ignore
  if (window.fbq) {
    // @ts-ignore
    delete window.fbq
    // @ts-ignore
    delete window._fbq
  }

  // Remove any existing fbevents scripts to prevent duplicates
  const existingScripts = document.querySelectorAll(
    'script[src*="fbevents.js"]',
  )
  existingScripts.forEach((s) => s.remove())

  // Fresh initialization
  // @ts-ignore
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  // @ts-ignore
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Init with the ONLY correct Pixel ID
  // @ts-ignore
  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  // @ts-ignore
  if (window.fbq) {
    // @ts-ignore
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  // @ts-ignore
  if (window.fbq) {
    // @ts-ignore
    window.fbq('track', 'AddToCart')
  }
}
